// Step 1: sign-up
export const LOAN_AMOUNT = 'loanAmount';
export const LOAN_TERM = 'loanTerm';
export const ORG_NUMBER = 'orgNumber';
export const EMAIL_ADDRESS = 'emailAddress';
export const TERMS_AGREEMENT = 'termsAgreement';
export const PHONE_NUMBER = 'phoneNumber';
export const PERSONAL_NUMBER = 'personalNumber';
export const TURNOVER = 'turnover';
export const WEBSITE = 'website';
export const HOME_ADDRESS = 'homeAddress';
export const HOUSE_NUMBER = 'houseNumber';
export const HOUSE_NUMBER_ADDITION = 'houseNumberAddition';
export const POST_CODE = 'postCode';
export const CITY = 'city';
export const STREET = 'street';
export const SET_HOME_ADDRESS_REQUEST_STATUS = 'setHomeAddressRequestStatus';
export const CARD_PURPOSE = 'cardPurpose';
export const CARD_PURPOSE_ADDITIONAL_INFO = 'cardPurposeAdditionalInfo';

// Step 2: onboarding
export const LOAN_PURPOSE = 'loanPurpose';
export const LOAN_PURPOSE_ADDITIONAL = 'loanPurposeAdditional';
export const BANK_INTEGRATION = 'bankIntegration';
export const DOCUMENT_UPLOAD = 'documentUpload';
export const CLEAR_DOCUMENT_UPLOAD = 'clearDocumentUpload';

// Widget context
export const SERVER_ERROR = 'serverError';
export const CLEAR_ERROR = 'clearError';
export const INVALID_ERROR = 'invalidError';
export const MISSING_ERROR = 'missingError';
export const NEXT_PAGE = 'nextPage';
export const PREVIOUS_PAGE = 'previousPage';
export const SET_CURRENT_PAGE = 'setCurrentPage';
export const SET_SIGNUP_COMPLETE = 'setSignupComplete';
export const SET_CARD_APPLICATION_ID = 'setCardApplicationId';
export const SET_SIGNUP_NEW_CUSTOMER = 'setSignupNewCustomer';
export const SET_ACCESS_TOKEN = 'setAccessToken';
export const SET_CLIENT_ID = 'setClientId';
export const SET_WIDGET_FINISHED = 'setWidgetFinished';
export const SET_WIDGET_LOADING = 'setWidgetLoading';
export const SET_WIDGET_INITIATED = 'setWidgetInitiated';
export const SET_IS_COMPANY_VALID = 'setIsCompanyValid';
export const SET_IS_ADDITIONAL_HOUSE_NUMBER_REQUIRED = 'SET_IS_ADDITIONAL_HOUSE_NUMBER_REQUIRED';

// General Form Actions
export const CLEAR_STATE = 'clearState';
